module.exports = __webpack_public_path__ + "b75900b94b280742c7aa212dc0b8f5a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pumpkin-s.png
// module id = 2100
// module chunks = 0